import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import App from '@zacousticrepo/grommet-v1-custom/components/App';
import Box from '@zacousticrepo/grommet-v1-custom/components/Box';

class MainPlain extends Component {
    constructor() {
        super();
    }

    render() {
        const { DisplayText } = this.props;

        return (
            <App centered={false}>
                <Box full={true} className="background-text" data-background-text={DisplayText}>
                    {this.props.children}
                </Box>
            </App>
        );
    }
}

MainPlain.propTypes = {
    children: PropTypes.any.isRequired,
    dispatch: PropTypes.func.isRequired,
    serverState: PropTypes.object
};

const mapStateToProps = state => ({ DisplayText: state.session.serverState.DisplayText });

export default connect(mapStateToProps)(MainPlain);
